import angrypirate from "../assets/propics/angrypirate_propic.PNG";
import cigardog from "../assets/propics/cigardog_propic.PNG";
import frown from "../assets/propics/frownpic.PNG";
import meditate from "../assets/propics/meditate_propic.PNG";
import smile from "../assets/propics/smilepic.PNG";

// The built-in profile pictures (Customize → Profile Picture). Only the ID is stored
// (users.avatar on the backend, `avatar` in every players payload) — the image itself
// ships with the frontend. The source images are rectangular; rendering them with
// object-fit:cover inside a circle crops to the centered inscribed circle (diameter =
// the rectangle's short side), which is the intended framing.
export const AVATARS = [
  { id: "angrypirate", label: "Angry Pirate", src: angrypirate },
  { id: "cigardog", label: "Cigar Dog", src: cigardog },
  { id: "frown", label: "Frown", src: frown },
  { id: "meditate", label: "Meditate", src: meditate },
  { id: "smile", label: "Smile", src: smile },
];

// Avatar id -> image src. Null/unknown ids (e.g. an id removed in a later build) return
// null, which renders as the default "P" placeholder circle.
export const avatarSrc = (id) => AVATARS.find((a) => a.id === id)?.src || null;
